import Box from '@mui/material/Box'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  imageContainer: {
    width: '100%',
    height: 300,
  },
  image: {
    width: '95%',
    height: '100%',
    objectFit: 'contain',
    margin: '0 2.5%',
  },
}))

const CarouselImageView = ({ imgInfo: { image = null } }) => {
  const classes = useStyles()
  return (
    <Box className={classes.imageContainer}>
      <img src={image} alt="" className={classes.image} />
    </Box>
  )
}

export default CarouselImageView
